// Sound-Lautstärke (Community-Wunsch) — rein clientseitige, per-Gerät-Einstellung für
// Spiel-Sounds (aktuell: Job-Event-Benachrichtigungston, playDecisionSound() in dashboard.ts).
// Persistiert bewusst in localStorage, nicht auf dem Server — betrifft ausschließlich die
// Wiedergabe im aktuellen Browser, kein anderer Spieler sieht diesen Wert je.

const SOUND_VOLUME_STORAGE_KEY = 'nt_sound_volume';
const DEFAULT_VOLUME_PERCENT = 100;

function clampPercent(value: number): number {
  if (!Number.isFinite(value)) return DEFAULT_VOLUME_PERCENT;
  return Math.min(100, Math.max(0, Math.round(value)));
}

/** Aktuelle Sound-Lautstärke in Prozent (0–100). Fällt auf 100 zurück, falls nie gesetzt. */
export function getSoundVolumePercent(): number {
  try {
    const raw = window.localStorage.getItem(SOUND_VOLUME_STORAGE_KEY);
    if (raw === null) return DEFAULT_VOLUME_PERCENT;
    return clampPercent(Number(raw));
  } catch {
    return DEFAULT_VOLUME_PERCENT;
  }
}

/** Speichert die Sound-Lautstärke (0–100, wird geklemmt). */
export function setSoundVolumePercent(percent: number): void {
  try {
    window.localStorage.setItem(SOUND_VOLUME_STORAGE_KEY, String(clampPercent(percent)));
  } catch {
    // Private-Browsing o.ä. — Einstellung gilt dann nur für die laufende Session im Speicher nicht,
    // aber ein fehlgeschlagener Schreibversuch darf nie einen Fehler werfen.
  }
}

/** Lautstärke als Faktor 0–1 für `HTMLAudioElement.volume`. */
export function getSoundVolumeFactor(): number {
  return getSoundVolumePercent() / 100;
}
